import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Image from '../components/Image';

const styles = theme => ({
    root: {
        position: 'absolute',
        width: '8%',
        maxWidth: 32,
    },
    tooltip: {
        backgroundColor: theme.palette.background.default,
        zIndex: 3
    }
});

const HotspotContent = (props) => (
    <div style={{padding: '1rem', width: 200, textAlign: 'center'}}>
        <Typography variant='subtitle1' style={{marginBottom: 10, textTransform: 'uppercase'}}>{props.title}</Typography>
        {props.content ? (
            <Typography variant='body2'>{props.content}</Typography>
        ) : (
            <React.Fragment>
                <Typography variant='body2'>Member Price: {props.member_price}</Typography>
                <Typography variant='body2'>Their Price: {props.their_price}</Typography>
                <Typography variant='body2' color='primary'>YOU SAVE:</Typography>
                <Typography variant='body2' color='primary'>{props.save}</Typography>
            </React.Fragment>
        )}
    </div>
)

class Hotspot extends React.Component {
    state = {
        open: false,
    }

    toggleContent = (open) => e => {
        const { callback } = this.props;
        this.setState({open});
        if (callback) {
            callback(open);
        }
    }

    render() {
        const { classes, img, left, top, title, content, prices={} } = this.props;
    
        return (
            <div className={classes.root} style={{top, left}}>
                <ClickAwayListener onClickAway={this.toggleContent(false)}>
                    <Tooltip
                    PopperProps={{
                        disablePortal: true,
                    }}
                    onClose={this.toggleContent(false)}
                    open={this.state.open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={<HotspotContent title={title} content={content} {...prices}/>}
                    classes={{tooltip: classes.tooltip}}
                    >
                        <Image src={img} width='100%' onClick={this.toggleContent(true)}/>
                    </Tooltip>
                </ClickAwayListener>
            </div>
        );
    }
}

Hotspot.propTypes = {
    classes: PropTypes.object.isRequired,
    img: PropTypes.string.isRequired,
    left: PropTypes.string.isRequired,
    top: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string,
    prices: PropTypes.object,
};

export default withStyles(styles)(Hotspot);